module.exports = __webpack_public_path__ + "img/banner2.055ce17e.png";